module.exports = __webpack_public_path__ + "static/media/goten-polar4-2.f18686f3.mp3";